<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                    'bg-gray-600': sharedService.userTheme === 'dark',
                    'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row padding10">
        <h4>PT Exception Report</h4>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-row gap-4">
    <div class="flex flex-row flex-wrap w-1/2 sm:flex-col gap-4">

      <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
            'bg-gray-700': sharedService.userTheme === 'dark',
            'bg-indigo-50': sharedService.userTheme === 'light'}">
        <mat-card-content>
          <div class="flex flex-col">
            <h5>Current PT Upload Exception Reports</h5>
            <div class="flex flex-row">
              <mat-form-field class="w-1/2">
                <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                  value="{{listFilter}}" />

                <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div style="overflow-x:auto">
              <div class="flex flex-row w-full">
                <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                  class="mat-elevation-z8 w-full" matSortActive="exceptionId" matSortDirection="desc">
                  <ng-container matColumnDef="evaluator">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Evaluator</th>
                    <td mat-cell *matCellDef="let item">{{item.evaluator}}</td>
                  </ng-container>
                  <ng-container matColumnDef="exceptionId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Loaded</th>
                    <td mat-cell *matCellDef="let item"><span hidden>{{item.exceptionId}} </span>{{item.dateCreated}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="errorMessage">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Error Message</th>
                    <td mat-cell *matCellDef="let item">{{item.errorMessage}}</td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="loadExceptions(row)"></tr>
                </table>
              </div>
            </div>
            <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
            </mat-paginator>
          </div>

        </mat-card-content>

      </mat-card>
    </div>
    <div class="flex flex-row flex-wrap w-1/2 sm:flex-col gap-4">

      <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
      'bg-gray-700': sharedService.userTheme === 'dark',
      'bg-indigo-50': sharedService.userTheme === 'light'}">
        <mat-card-content>
          <div class="flex flex-col">
            <h5>Historical PT Upload Exception Reports</h5>
            <div class="flex flex-row">
              <mat-form-field class="w-1/2">
                <input matInput id="listFilter2" (keyup)="filterTable2($event)" placeholder="Filter2"
                  value="{{listFilter2}}" />

                <button *ngIf="listFilter2" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter2()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div style="overflow-x:auto">
              <div class="flex flex-row">
                <table mat-table [dataSource]="dataSource2" multiTemplateDataRows matSort #TableSort="matSort"
                  class="mat-elevation-z8 w-full" matSortActive="majorCat" matSortDirection="asc">
                  <ng-container matColumnDef="view">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>View</th>
                    <td mat-cell *matCellDef="let item2">{{item2.code}}</td>
                  </ng-container>
                  <ng-container matColumnDef="evaluator">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Evaluator</th>
                    <td mat-cell *matCellDef="let item2">{{item2.evaluator}}</td>
                  </ng-container>
                  <ng-container matColumnDef="ptType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                    <td mat-cell *matCellDef="let item2">{{item2.ptType}}</td>
                  </ng-container>
                  <ng-container matColumnDef="dateCreated">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Loaded</th>
                    <td mat-cell *matCellDef="let item2">{{item2.dateCreated}}</td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                </table>
              </div>
            </div>
            <mat-paginator [pageSizeOptions]="getPageSizeOptions2()" #TablePaginator="matPaginator"
              showFirstLastButtons>
            </mat-paginator>
          </div>

        </mat-card-content>

      </mat-card>
    </div>
  </div>

</div>